import { LOGIN_FAIL, LOGIN_SUCCESS } from "../types"

const initState = {
    uid: null,
}

const authUser = (state = initState, action) => {
    switch (action.type) {
        case LOGIN_SUCCESS:
            return {
                ...state,
                uid: action.payload,
            }
        case LOGIN_FAIL:
            localStorage.clear()
            return {
                ...state,
                uid: null,
            }
        default:
            return {
                ...state
            }
    }
}
export default authUser